'use client';

import { useTranslations } from 'next-intl';
import { ListPageHeader } from '@terra/ui-design-system';

export function FindingsPageHeader() {
  const t = useTranslations('proxy.findings.page');

  return <ListPageHeader title={t('title')} subtitle={t('subtitle')} />;
}
